import type { AsyncSequence } from "../types/AsyncSequence"

/**
 * Converts one or more async sequences into a single array.
 * All values are collected in memory before returning.
 *
 * @param arrays - One or more async sequences to convert to an array
 * @returns A promise that resolves to an array containing all values
 *
 * @example
 * ```ts
 * import { IterableToArray } from "@pdfking/tfunc"
 *
 * async function* numbers() {
 *   yield 1;
 *   yield 2;
 *   yield 3;
 * }
 *
 * const array = await IterableToArray(numbers());
 * console.log(array); // [1, 2, 3]
 * ```
 */
export const IterableToArray = async <T>(
  ...arrays: AsyncSequence<T>[]
): Promise<T[]> => {
  const res = []
  for (const array of arrays) {
    for await (const item of array) {
      res.push(item)
    }
  }
  return res
}
